import { render, staticRenderFns } from "./ag-icon-header.vue?vue&type=template&id=a94b387c&scoped=true"
import script from "./ag-icon-header.vue?vue&type=script&lang=js"
export * from "./ag-icon-header.vue?vue&type=script&lang=js"
import style0 from "./ag-icon-header.vue?vue&type=style&index=0&id=a94b387c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b387c",
  null
  
)

export default component.exports